// Chaînes de la page publique de paiement par lien magique (/pay/:token).
// Clés préfixées "pay." — voir i18n/index.js pour la convention.
// ⚠️ Les valeurs backend (motive, description, statuts) ne sont PAS traduites.
const pay = {
  fr: {
    // — Header / footer —
    "pay.secure_badge": "Paiement sécurisé · Stripe",
    "pay.footer_secure_title": "Paiement 100 % sécurisé.",
    "pay.footer_secure_body":
      "Vos informations bancaires sont chiffrées de bout en bout et traitées par Stripe. Terouma ne stocke aucune donnée carte.",
    "pay.demo_banner": "Mode démo · aucun débit réel n'est effectué.",
    "pay.motto": "Téchouvah · Téfila · Tsédaka",

    // — « Je paierai plus tard » (commande publique à confirmer) —
    "pay.later_title": "Vous préférez payer plus tard ?",
    "pay.later_hint":
      "Un clic suffit : votre engagement est enregistré, et votre lien de paiement vous est envoyé par email — à utiliser quand vous le souhaitez.",
    "pay.later_button": "Je paierai plus tard",
    "pay.later_done_title": "C'est noté — votre engagement est enregistré",
    "pay.later_done_body":
      "Votre lien de paiement vous a été envoyé par email (simple mémo, rien à faire). Vous pouvez fermer cette page, ou régler dès maintenant ci-dessous.",
    "pay.later_done_body_noemail":
      "Gardez ce lien de côté pour régler quand vous le souhaiterez. Vous pouvez fermer cette page.",
    "pay.later_error": "Enregistrement impossible — réessayez.",
    // — Adresse du reçu fiscal (lien vérifié, fiche sans adresse complète) —
    "pay.address_title": "Adresse pour votre reçu fiscal",
    "pay.address_optional": "(facultatif)",
    "pay.address_hint": "Votre fiche n'a pas d'adresse complète : la synagogue en a besoin pour établir votre reçu fiscal.",
    "pay.address_add": "Ajouter",
    "pay.address_street": "Adresse (numéro et rue)",
    "pay.address_postal": "Code postal",
    "pay.address_city": "Ville",
    "pay.address_save": "Enregistrer",
    "pay.address_later": "Plus tard",
    "pay.address_saved": "Adresse enregistrée pour votre reçu fiscal.",
    "pay.address_error": "Enregistrement impossible — réessayez.",

    // — Erreurs (boundary, chargement, paiement) —
    "pay.error_title": "Une erreur est survenue",
    "pay.boundary_body": "Le paiement n'a pas pu s'afficher. Rechargez la page.",
    "pay.boundary_reload": "Recharger la page",
    "pay.error_timeout": "La requête a expiré. Vérifiez votre connexion et réessayez.",
    "pay.error_load": "Impossible de charger le paiement.",
    "pay.error_init": "Impossible d'initier le paiement.",
    "pay.error_fallback": "Le paiement n'a pas pu aboutir.",
    "pay.payment_failed": "Le paiement a échoué.",
    "pay.payment_not_confirmed": "Paiement non confirmé.",

    // — Carte principale (liste des engagements) —
    "pay.personal_link": "Lien de paiement personnel",
    "pay.hello": "Chalom {name}.",
    "pay.thanks_prefix": "Le ",
    "pay.thanks_suffix": " vous remercie de votre engagement.",
    "pay.pending_title": "Mes engagements en attente",
    "pay.expires": "Expire le {date}",
    "pay.donation_date": "Don du {date}",
    "pay.installment_line": "Échéance #{seq} sur {total} · {date}",
    "pay.one_time": "Don ponctuel",
    "pay.of_total": "sur {amount}",
    "pay.auto_active": "🔁 Prélèvement automatique actif",
    "pay.auto_active_next": "🔁 Prélèvement automatique actif · prochain le {date}",
    "pay.stop": "Arrêter",

    // — « Je couvre les frais » —
    "pay.cover_fees_label": "Je couvre les frais Stripe",
    "pay.cover_fees_hint":
      "Les frais de transaction Stripe (1,5% + 0,25 €) seront ajoutés à votre don pour que la synagogue reçoive l'intégralité du montant. Sinon, ils seront retenus par Stripe sur la somme reçue par la synagogue.",
    "pay.line_donation": "Don à la synagogue",
    "pay.line_fees": "Frais Stripe",
    "pay.total_due": "Total à régler",

    // — Particulier / entreprise —
    "pay.pay_as": "Vous payez en tant que",
    "pay.pay_as_self": "Moi-même",
    "pay.pay_as_self_hint": "Particulier · 66 %",
    "pay.pay_as_company": "Ma société",
    "pay.pay_as_company_hint": "Entreprise · 60 %",
    "pay.civility_placeholder": "Civilité (M./Mme)",
    "pay.company_address_placeholder": "Adresse du siège — commencez à taper…",
    "pay.company_cerfa_note":
      "Reçu Cerfa « personne morale » — article 238 bis, réduction 60 %.",

    // — Prélèvement automatique (abonnement) —
    "pay.auto_title": "Prélever automatiquement les échéances suivantes",
    "pay.auto_body_1": "En cochant, vous souscrivez un ",
    "pay.auto_body_sub": "abonnement de paiement",
    "pay.auto_body_2":
      " : après le paiement d'aujourd'hui, votre carte sera débitée automatiquement de ",
    "pay.auto_body_amount": "{amount} par mois",
    "pay.auto_body_3": " jusqu'au solde des {count} échéance(s) restante(s). ",
    "pay.auto_body_cancel": "Résiliable à tout moment",
    "pay.auto_body_4":
      " depuis ce lien, sans frais. Vous recevrez un reçu pour chaque prélèvement.",

    // — CTA & checkout —
    "pay.select_one": "Sélectionnez au moins un engagement",
    "pay.continue": "Continuer vers le paiement",
    "pay.pay_amount": "Payer {amount}",
    "pay.edit_selection": "Modifier la sélection",
    "pay.payment_to": "Paiement vers {org}",
    "pay.demo_hint": "Mode démo — utilisez 4242 4242 4242 4242 pour simuler un paiement.",
    "pay.demo_error": "Erreur démo.",
    "pay.card_number": "Numéro de carte",
    "pay.card_expiry": "Expiration",

    // — Étalement en plusieurs fois —
    "pay.split_toggle": "Étaler sur plusieurs mois",
    "pay.split_toggle_change": "Payer en 1 fois ou changer le rythme",
    "pay.split_once": "Tout régler aujourd'hui : {amount}",
    "pay.split_title": "Étaler {amount} sur :",
    "pay.split_per_month": "{n} × {amount} / mois",

    // — Succès —
    "pay.success_title": "Merci, {name}.",
    "pay.success_1": "Votre don de ",
    "pay.success_2": " au ",
    "pay.success_3": " a bien été enregistré.",
    "pay.success_receipt":
      "Votre reçu fiscal Cerfa vous sera envoyé par email dans les prochaines minutes.",
    "pay.auto_on_title": "Abonnement activé.",
    "pay.auto_on_body":
      " Les échéances restantes seront prélevées automatiquement chaque mois sur cette carte (prochain prélèvement dans ~30 jours). Résiliable à tout moment en revenant sur ce lien — bouton « Arrêter ».",
  },
  en: {
    // — Header / footer —
    "pay.secure_badge": "Secure payment · Stripe",
    "pay.footer_secure_title": "100% secure payment.",
    "pay.footer_secure_body":
      "Your card details are encrypted end-to-end and processed by Stripe. Terouma never stores any card data.",
    "pay.demo_banner": "Demo mode · no real charge will be made.",
    "pay.motto": "Teshuvah · Tefillah · Tzedakah",

    // — "Pay later" (public order awaiting confirmation) —
    "pay.later_title": "Prefer to pay later?",
    "pay.later_hint":
      "One click is enough: your pledge is saved and your payment link is emailed to you — use it whenever you like.",
    "pay.later_button": "I'll pay later",
    "pay.later_done_title": "All set — your pledge is saved",
    "pay.later_done_body":
      "Your payment link was emailed to you (just a memo, nothing to do). You can close this page, or pay right now below.",
    "pay.later_done_body_noemail":
      "Keep this link handy to pay whenever you like. You can close this page.",
    "pay.later_error": "Could not save — please retry.",
    "pay.address_title": "Address for your tax receipt",
    "pay.address_optional": "(optional)",
    "pay.address_hint": "Your record has no complete address: the synagogue needs it to issue your tax receipt.",
    "pay.address_add": "Add",
    "pay.address_street": "Address (number and street)",
    "pay.address_postal": "Postal code",
    "pay.address_city": "City",
    "pay.address_save": "Save",
    "pay.address_later": "Later",
    "pay.address_saved": "Address saved for your tax receipt.",
    "pay.address_error": "Could not save — please retry.",

    // — Errors (boundary, loading, payment) —
    "pay.error_title": "Something went wrong",
    "pay.boundary_body": "The payment page could not be displayed. Please reload the page.",
    "pay.boundary_reload": "Reload the page",
    "pay.error_timeout": "The request timed out. Please check your connection and try again.",
    "pay.error_load": "We couldn't load your payment details.",
    "pay.error_init": "We couldn't start the payment. Please try again.",
    "pay.error_fallback": "The payment could not be completed.",
    "pay.payment_failed": "The payment failed.",
    "pay.payment_not_confirmed": "Payment not confirmed.",

    // — Main card (pledge list) —
    "pay.personal_link": "Personal payment link",
    "pay.hello": "Shalom {name}.",
    "pay.thanks_prefix": "",
    "pay.thanks_suffix": " warmly thanks you for your pledge.",
    "pay.pending_title": "My pending pledges",
    "pay.expires": "Expires on {date}",
    "pay.donation_date": "Pledged on {date}",
    "pay.installment_line": "Installment #{seq} of {total} · {date}",
    "pay.one_time": "One-time donation",
    "pay.of_total": "of {amount}",
    "pay.auto_active": "🔁 Automatic payments active",
    "pay.auto_active_next": "🔁 Automatic payments active · next charge on {date}",
    "pay.stop": "Stop",

    // — "I'll cover the fees" —
    "pay.cover_fees_label": "I'll cover the Stripe fees",
    "pay.cover_fees_hint":
      "Stripe's processing fee (1.5% + €0.25) will be added to your donation so the synagogue receives the full amount. Otherwise, the fee is deducted from the amount the synagogue receives.",
    "pay.line_donation": "Donation to the synagogue",
    "pay.line_fees": "Stripe fees",
    "pay.total_due": "Total due",

    // — Individual / company —
    "pay.pay_as": "You are paying as",
    "pay.pay_as_self": "Myself",
    "pay.pay_as_self_hint": "Individual · 66%",
    "pay.pay_as_company": "My company",
    "pay.pay_as_company_hint": "Business · 60%",
    "pay.civility_placeholder": "Title (Mr/Mrs)",
    "pay.company_address_placeholder": "Registered office address — start typing…",
    "pay.company_cerfa_note":
      "Corporate Cerfa (French tax receipt) — Article 238 bis, 60% tax deduction.",

    // — Automatic payments (subscription) —
    "pay.auto_title": "Automatically charge the remaining installments",
    "pay.auto_body_1": "By ticking this box, you set up a ",
    "pay.auto_body_sub": "payment subscription",
    "pay.auto_body_2":
      ": after today's payment, your card will automatically be charged ",
    "pay.auto_body_amount": "{amount} per month",
    "pay.auto_body_3": " until the {count} remaining installment(s) are settled. ",
    "pay.auto_body_cancel": "Cancel anytime",
    "pay.auto_body_4":
      " from this link, at no cost. You will receive a receipt for every payment.",

    // — CTA & checkout —
    "pay.select_one": "Select at least one pledge",
    "pay.continue": "Continue to payment",
    "pay.pay_amount": "Pay {amount}",
    "pay.edit_selection": "Edit selection",
    "pay.payment_to": "Payment to {org}",
    "pay.demo_hint": "Demo mode — use 4242 4242 4242 4242 to simulate a payment.",
    "pay.demo_error": "Demo error.",
    "pay.card_number": "Card number",
    "pay.card_expiry": "Expiry date",

    // — Split into installments —
    "pay.split_toggle": "Spread over several months",
    "pay.split_toggle_change": "Pay at once or change the schedule",
    "pay.split_once": "Pay everything today: {amount}",
    "pay.split_title": "Split {amount} into:",
    "pay.split_per_month": "{n} × {amount} / month",

    // — Success —
    "pay.success_title": "Thank you, {name}.",
    "pay.success_1": "Your donation of ",
    "pay.success_2": " to ",
    "pay.success_3": " has been received.",
    "pay.success_receipt":
      "Your Cerfa tax receipt will be emailed to you within the next few minutes.",
    "pay.auto_on_title": "Subscription activated.",
    "pay.auto_on_body":
      " The remaining installments will be charged to this card automatically each month (next charge in about 30 days). Cancel anytime by returning to this link — using the \"Stop\" button.",
  },
};

export default pay;
